import { formatDistanceToNow, parseISO } from 'date-fns';
import { ptBR, enUS, es } from 'date-fns/locale';
import { useI18n } from 'vue-i18n';

// O helper de tempo do OS (shared/helpers/timeHelper) só fala inglês e espera
// timestamp Unix; a API do PowerData devolve ISO 8601. Este composable cobre os
// dois buracos sem tocar no helper compartilhado.
const LOCALES = {
  pt_BR: ptBR,
  pt: ptBR,
  es: es,
  en: enUS,
};

export function useRelativeTime() {
  const { locale } = useI18n();

  const relativeTime = value => {
    if (!value) return '—';
    const date = typeof value === 'string' ? parseISO(value) : new Date(value);
    if (Number.isNaN(date.getTime())) return '—';
    return formatDistanceToNow(date, {
      addSuffix: true,
      locale: LOCALES[locale.value] || enUS,
    });
  };

  return { relativeTime };
}
